// extracted by mini-css-extract-plugin
module.exports = {"wireless":"wireless-3hsCTSa4","link":"link-ZoUg5Hmi","list":"list-1DCBNKCh clearfix"};